import { Component, Input } from '@angular/core';
import { ClockComponent } from '@shared/components/layout/headers/clock/clock.component';
import { LanguageSelectorComponent } from "@shared/components/layout/headers/language-selector/language-selector.component";

import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-unlogged-header',
    imports: [ClockComponent, LanguageSelectorComponent, RouterModule],
    templateUrl: './unlogged-header.component.html',
    styleUrl: './unlogged-header.component.scss'
})
export class UnloggedHeaderComponent {
  @Input() titleText: string = '';
}
